var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIndiaFlag = function SvgIndiaFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.27 6.562H0V.518C0 .232.25 0 .556 0h31.158c.308 0 .557.232.557.518v6.044Z",
    fill: "#FAA646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.714 19.685H.556c-.307 0-.556-.232-.556-.518v-6.044h32.27v6.044c0 .286-.248.518-.556.518Z",
    fill: "#73AF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 6.561h32.271v6.561H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.145 9.843c0 1.536 1.341 2.785 2.99 2.785 1.65 0 2.99-1.25 2.99-2.785 0-1.535-1.34-2.784-2.99-2.784-1.649 0-2.99 1.25-2.99 2.784Zm.555 0c0-1.25 1.092-2.266 2.434-2.266 1.343 0 2.435 1.017 2.435 2.267s-1.092 2.266-2.435 2.266c-1.342 0-2.434-1.016-2.434-2.266Z",
    fill: "#41479B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.135,
    cy: 9.843,
    rx: 0.339,
    ry: 0.316,
    fill: "#41479B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.135 9.89-.861.082-1.851-.081v-.095l1.85-.081.862.08v.096ZM16.135 9.89l.861.082 1.851-.081v-.095l-1.85-.081-.862.08v.096Z",
    fill: "#41479B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16.085 9.843-.087-.802.087-1.724h.102l.087 1.724-.087.802h-.102Z",
    fill: "#41479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m16.085 9.842-.087.803.087 1.723h.102l.087-1.723-.087-.803h-.102Z",
    fill: "#41479B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m16.099 9.877-.671-.51L14.18 8.09l.072-.067 1.37 1.161.548.625-.072.067Z",
    fill: "#41479B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1 9.876.547.625 1.37 1.161.072-.067-1.247-1.276-.67-.51-.072.067Z",
    fill: "#41479B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m16.1 9.81.547-.625 1.37-1.161.072.067-1.247 1.276-.67.51-.072-.067Z",
    fill: "#41479B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m16.099 9.81-.671.51-1.247 1.275.072.067 1.37-1.161.548-.625-.072-.066Z",
    fill: "#41479B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m16.155 9.887-.763.382-1.743.584-.039-.087 1.677-.735.83-.232.038.088Z",
    fill: "#41479B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m16.154 9.887.83-.232 1.676-.734-.039-.088-1.743.585-.763.381.04.088Z",
    fill: "#41479B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m16.089 9.862-.41-.71-.628-1.623.094-.036.788 1.56.25.773-.094.036Z",
    fill: "#41479B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m16.088 9.861.25.772.788 1.562.094-.037-.628-1.623-.41-.71-.094.036Z",
    fill: "#41479B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m16.116 9.887-.829-.232-1.677-.734.04-.088 1.742.585.763.381-.039.088Z",
    fill: "#41479B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m16.115 9.887.763.382 1.743.584.04-.087-1.678-.735-.829-.232-.039.088Z",
    fill: "#41479B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m16.088 9.826.25-.772.788-1.561.094.036-.628 1.623-.41.71-.094-.036Z",
    fill: "#41479B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m16.089 9.826-.41.71-.628 1.623.094.036.788-1.561.25-.772-.094-.036Z",
    fill: "#41479B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.135,
    cy: 9.843,
    rx: 0.457,
    ry: 0.426,
    fill: "#F5F5F5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.136,
    cy: 9.843,
    rx: 0.274,
    ry: 0.255,
    fill: "#41479B"
  })));
};
export default SvgIndiaFlag;